const menuItems = [
    { to: '/', label: 'Home' },
    { to: '/about-us', label: 'ABOUT US' },
    { to: '/services', label: 'SERVICES' },
    { to: '/contact-us', label: 'CONTACT US' }
];

export { menuItems }